import { StringOfMax60Chars } from "./strings";
import { HasToJson, HasValidationSchema } from "./template-headers";
import * as yup from "yup";

/** Accepts no templates. */
export class MetaTemplateFooter implements HasToJson, HasValidationSchema {
    constructor(public text: StringOfMax60Chars = '' as StringOfMax60Chars) {}
    type = "footer"
    toJson() {
        return JSON.stringify({
            type: this.type, 
            text: this.text
        })
    }
    parse(str: string) {
        return JSON.parse(str) as { type: "footer", text: StringOfMax60Chars }
    }
    getValidationSchema() {
        return yup.object({
            text: yup.string().max(60,'O texto do footer deve ter até 60 caracters.').required('O texto do footer é obrigatório.')
        })
    }
}